var map = {
	"./En/about-yfc/about-yfc": [
		"RD1c",
		36
	],
	"./En/about-yfc/about-yfc.vue": [
		"RD1c",
		36
	],
	"./En/investment/finance-information/company-annual-report": [
		"N3hs",
		46
	],
	"./En/investment/finance-information/company-annual-report.vue": [
		"N3hs",
		46
	],
	"./En/investment/finance-information/financial-report": [
		"HTWw",
		54
	],
	"./En/investment/finance-information/financial-report.vue": [
		"HTWw",
		54
	],
	"./En/investment/finance-information/monthly-revenue-information": [
		"ar+n",
		94
	],
	"./En/investment/finance-information/monthly-revenue-information.vue": [
		"ar+n",
		94
	],
	"./En/investment/finance-information/monthly-surplus": [
		"LdBV",
		93
	],
	"./En/investment/finance-information/monthly-surplus.vue": [
		"LdBV",
		93
	],
	"./En/investment/shareholder-service/institutional-investors": [
		"28ie",
		29
	],
	"./En/investment/shareholder-service/institutional-investors.vue": [
		"28ie",
		29
	],
	"./En/investment/shareholder-service/material-information": [
		"ui88",
		53
	],
	"./En/investment/shareholder-service/material-information.vue": [
		"ui88",
		53
	],
	"./En/investment/shareholder-service/shareholders-meeting": [
		"Qyqb",
		12
	],
	"./En/investment/shareholder-service/shareholders-meeting.vue": [
		"Qyqb",
		12
	],
	"./En/product-service/product-service": [
		"eUyW",
		47
	],
	"./En/product-service/product-service.vue": [
		"eUyW",
		47
	],
	"./En/site/site-tour": [
		"OO54",
		92
	],
	"./En/site/site-tour.vue": [
		"OO54",
		92
	],
	"./En/sustainability/sustainability": [
		"mIiX",
		39
	],
	"./En/sustainability/sustainability.vue": [
		"mIiX",
		39
	],
	"./Index": [
		"A3Wa",
		1
	],
	"./Index.vue": [
		"A3Wa",
		1
	],
	"./Index_en": [
		"TyQH",
		2
	],
	"./Index_en.vue": [
		"TyQH",
		2
	],
	"./Layout": [
		"Bv40",
		0
	],
	"./Layout.vue": [
		"Bv40",
		0
	],
	"./Tw/about-tac/certificate": [
		"ysEt",
		91
	],
	"./Tw/about-tac/certificate.vue": [
		"ysEt",
		91
	],
	"./Tw/about-tac/management-group": [
		"MuZJ",
		90
	],
	"./Tw/about-tac/management-group.vue": [
		"MuZJ",
		90
	],
	"./Tw/about-tac/management-philosophy": [
		"VZUw",
		33
	],
	"./Tw/about-tac/management-philosophy.vue": [
		"VZUw",
		33
	],
	"./Tw/about-tac/news-center": [
		"xevI",
		20
	],
	"./Tw/about-tac/news-center.vue": [
		"xevI",
		20
	],
	"./Tw/about-tac/related-company": [
		"uCLN",
		89
	],
	"./Tw/about-tac/related-company.vue": [
		"uCLN",
		89
	],
	"./Tw/about-tac/service-dealer": [
		"o2vK",
		59
	],
	"./Tw/about-tac/service-dealer.vue": [
		"o2vK",
		59
	],
	"./Tw/business/business": [
		"HD2X",
		32
	],
	"./Tw/business/business.vue": [
		"HD2X",
		32
	],
	"./Tw/investment/company-information/company-info": [
		"cDVw",
		52
	],
	"./Tw/investment/company-information/company-info.vue": [
		"cDVw",
		52
	],
	"./Tw/investment/company-information/credit-rating": [
		"BLKP",
		88
	],
	"./Tw/investment/company-information/credit-rating.vue": [
		"BLKP",
		88
	],
	"./Tw/investment/company-information/csr-download": [
		"QrbU",
		87
	],
	"./Tw/investment/company-information/csr-download.vue": [
		"QrbU",
		87
	],
	"./Tw/investment/company-information/identification-of-stakeholders": [
		"yWQG",
		86
	],
	"./Tw/investment/company-information/identification-of-stakeholders.vue": [
		"yWQG",
		86
	],
	"./Tw/investment/finance-information/company-annual-report": [
		"WUEQ",
		85
	],
	"./Tw/investment/finance-information/company-annual-report.vue": [
		"WUEQ",
		85
	],
	"./Tw/investment/finance-information/financial-report": [
		"96fF",
		50
	],
	"./Tw/investment/finance-information/financial-report.vue": [
		"96fF",
		50
	],
	"./Tw/investment/finance-information/monthly-revenue-information": [
		"0Ilh",
		84
	],
	"./Tw/investment/finance-information/monthly-revenue-information.vue": [
		"0Ilh",
		84
	],
	"./Tw/investment/finance-information/monthly-surplus": [
		"QktP",
		83
	],
	"./Tw/investment/finance-information/monthly-surplus.vue": [
		"QktP",
		83
	],
	"./Tw/investment/shareholder-service/dividend-distribution": [
		"Ub2N",
		42
	],
	"./Tw/investment/shareholder-service/dividend-distribution.vue": [
		"Ub2N",
		42
	],
	"./Tw/investment/shareholder-service/institutional-investors": [
		"EZBJ",
		34
	],
	"./Tw/investment/shareholder-service/institutional-investors.vue": [
		"EZBJ",
		34
	],
	"./Tw/investment/shareholder-service/material-information": [
		"+Za0",
		55
	],
	"./Tw/investment/shareholder-service/material-information.vue": [
		"+Za0",
		55
	],
	"./Tw/investment/shareholder-service/operational-summary": [
		"RmS+",
		45
	],
	"./Tw/investment/shareholder-service/operational-summary.vue": [
		"RmS+",
		45
	],
	"./Tw/investment/shareholder-service/shareholder-structure": [
		"e8Ac",
		82
	],
	"./Tw/investment/shareholder-service/shareholder-structure.vue": [
		"e8Ac",
		82
	],
	"./Tw/investment/shareholder-service/shareholders-meeting": [
		"lhmd",
		11
	],
	"./Tw/investment/shareholder-service/shareholders-meeting.vue": [
		"lhmd",
		11
	],
	"./Tw/investment/shareholder-service/stock-affairs": [
		"igOA",
		81
	],
	"./Tw/investment/shareholder-service/stock-affairs.vue": [
		"igOA",
		81
	],
	"./Tw/investment/shareholder-service/stock-price-information": [
		"5fHk",
		80
	],
	"./Tw/investment/shareholder-service/stock-price-information.vue": [
		"5fHk",
		80
	],
	"./Tw/product-service/cn-business/cn-car-rent": [
		"yWTS",
		79
	],
	"./Tw/product-service/cn-business/cn-car-rent.vue": [
		"yWTS",
		79
	],
	"./Tw/product-service/cn-business/cn-carloan-installments": [
		"iVDG",
		78
	],
	"./Tw/product-service/cn-business/cn-carloan-installments.vue": [
		"iVDG",
		78
	],
	"./Tw/product-service/cn-business/cn-equipment-leasing": [
		"ffnB",
		77
	],
	"./Tw/product-service/cn-business/cn-equipment-leasing.vue": [
		"ffnB",
		77
	],
	"./Tw/product-service/cn-business/cn-vehicle-auction": [
		"MvBf",
		76
	],
	"./Tw/product-service/cn-business/cn-vehicle-auction.vue": [
		"MvBf",
		76
	],
	"./Tw/product-service/ph-business/ph-carloan-installments": [
		"IBBT",
		75
	],
	"./Tw/product-service/ph-business/ph-carloan-installments.vue": [
		"IBBT",
		75
	],
	"./Tw/product-service/product-service": [
		"wSZu",
		57
	],
	"./Tw/product-service/product-service.vue": [
		"wSZu",
		57
	],
	"./Tw/product-service/tw-business/car-shop": [
		"Ny1g",
		74
	],
	"./Tw/product-service/tw-business/car-shop.vue": [
		"Ny1g",
		74
	],
	"./Tw/product-service/tw-business/energy-service": [
		"VX9G",
		73
	],
	"./Tw/product-service/tw-business/energy-service.vue": [
		"VX9G",
		73
	],
	"./Tw/product-service/tw-business/taiwan-car-rent": [
		"HwU3",
		72
	],
	"./Tw/product-service/tw-business/taiwan-car-rent.vue": [
		"HwU3",
		72
	],
	"./Tw/product-service/tw-business/taiwan-carloan-installments": [
		"rDOi",
		71
	],
	"./Tw/product-service/tw-business/taiwan-carloan-installments.vue": [
		"rDOi",
		71
	],
	"./Tw/product-service/tw-business/taiwan-corporate-finance": [
		"6Wpi",
		70
	],
	"./Tw/product-service/tw-business/taiwan-corporate-finance.vue": [
		"6Wpi",
		70
	],
	"./Tw/product-service/tw-business/taiwan-product-installments": [
		"4xCS",
		69
	],
	"./Tw/product-service/tw-business/taiwan-product-installments.vue": [
		"4xCS",
		69
	],
	"./Tw/product-service/tw-business/tw-equipment-leasing": [
		"yFcv",
		68
	],
	"./Tw/product-service/tw-business/tw-equipment-leasing.vue": [
		"yFcv",
		68
	],
	"./Tw/recruiting/nurture": [
		"ulMe",
		40
	],
	"./Tw/recruiting/nurture.vue": [
		"ulMe",
		40
	],
	"./Tw/recruiting/recruit": [
		"EI4U",
		67
	],
	"./Tw/recruiting/recruit.vue": [
		"EI4U",
		67
	],
	"./Tw/recruiting/recruit_new": [
		"96M0",
		5
	],
	"./Tw/recruiting/recruit_new.vue": [
		"96M0",
		5
	],
	"./Tw/recruiting/recruit_new2": [
		"NodO",
		6
	],
	"./Tw/recruiting/recruit_new2.vue": [
		"NodO",
		6
	],
	"./Tw/recruiting/salary": [
		"sx8o",
		56
	],
	"./Tw/recruiting/salary.vue": [
		"sx8o",
		56
	],
	"./Tw/recruiting/talent-sustainability": [
		"aw+a",
		28
	],
	"./Tw/recruiting/talent-sustainability.vue": [
		"aw+a",
		28
	],
	"./Tw/site/site-tour": [
		"dOWE",
		66
	],
	"./Tw/site/site-tour.vue": [
		"dOWE",
		66
	],
	"./Tw/stakeholder/stakeholder": [
		"CAqE",
		27
	],
	"./Tw/stakeholder/stakeholder.vue": [
		"CAqE",
		27
	],
	"./Tw/sustainable-development/customer-worth/aaaTest": [
		"/Zxw",
		60
	],
	"./Tw/sustainable-development/customer-worth/aaaTest.vue": [
		"/Zxw",
		60
	],
	"./Tw/sustainable-development/customer-worth/customer-privacy": [
		"fPtL",
		48
	],
	"./Tw/sustainable-development/customer-worth/customer-privacy.vue": [
		"fPtL",
		48
	],
	"./Tw/sustainable-development/customer-worth/customer-relationship": [
		"m1Lu",
		24
	],
	"./Tw/sustainable-development/customer-worth/customer-relationship.vue": [
		"m1Lu",
		24
	],
	"./Tw/sustainable-development/customer-worth/customer-service": [
		"pdRf",
		31
	],
	"./Tw/sustainable-development/customer-worth/customer-service.vue": [
		"pdRf",
		31
	],
	"./Tw/sustainable-development/environment-sustainable/carbon-reduction": [
		"Oc7o",
		61
	],
	"./Tw/sustainable-development/environment-sustainable/carbon-reduction.vue": [
		"Oc7o",
		61
	],
	"./Tw/sustainable-development/environment-sustainable/climate-change": [
		"HX+V",
		17
	],
	"./Tw/sustainable-development/environment-sustainable/climate-change.vue": [
		"HX+V",
		17
	],
	"./Tw/sustainable-development/environment-sustainable/development-green-energy": [
		"X8TI",
		10
	],
	"./Tw/sustainable-development/environment-sustainable/development-green-energy.vue": [
		"X8TI",
		10
	],
	"./Tw/sustainable-development/environment-sustainable/environmental-protection": [
		"02mD",
		9
	],
	"./Tw/sustainable-development/environment-sustainable/environmental-protection.vue": [
		"02mD",
		9
	],
	"./Tw/sustainable-development/environment-sustainable/green-sustainable": [
		"rtwt",
		43
	],
	"./Tw/sustainable-development/environment-sustainable/green-sustainable.vue": [
		"rtwt",
		43
	],
	"./Tw/sustainable-development/environment-sustainable/supplier-management": [
		"9Ad+",
		13
	],
	"./Tw/sustainable-development/environment-sustainable/supplier-management.vue": [
		"9Ad+",
		13
	],
	"./Tw/sustainable-development/happy-workplace/cultivation-and-development": [
		"uBUO",
		25
	],
	"./Tw/sustainable-development/happy-workplace/cultivation-and-development.vue": [
		"uBUO",
		25
	],
	"./Tw/sustainable-development/happy-workplace/employee-care": [
		"56Av",
		7
	],
	"./Tw/sustainable-development/happy-workplace/employee-care.vue": [
		"56Av",
		7
	],
	"./Tw/sustainable-development/happy-workplace/human-right": [
		"Wpo0",
		21
	],
	"./Tw/sustainable-development/happy-workplace/human-right.vue": [
		"Wpo0",
		21
	],
	"./Tw/sustainable-development/happy-workplace/human-structure": [
		"sobo",
		37
	],
	"./Tw/sustainable-development/happy-workplace/human-structure.vue": [
		"sobo",
		37
	],
	"./Tw/sustainable-development/happy-workplace/industrial-relations": [
		"q5s/",
		41
	],
	"./Tw/sustainable-development/happy-workplace/industrial-relations.vue": [
		"q5s/",
		41
	],
	"./Tw/sustainable-development/operating-governance/compliance": [
		"X2mK",
		35
	],
	"./Tw/sustainable-development/operating-governance/compliance.vue": [
		"X2mK",
		35
	],
	"./Tw/sustainable-development/operating-governance/corporate-governance": [
		"gEgt",
		30
	],
	"./Tw/sustainable-development/operating-governance/corporate-governance.vue": [
		"gEgt",
		30
	],
	"./Tw/sustainable-development/operating-governance/information-disclosure": [
		"zmQa",
		65
	],
	"./Tw/sustainable-development/operating-governance/information-disclosure.vue": [
		"zmQa",
		65
	],
	"./Tw/sustainable-development/operating-governance/integrity-management": [
		"M0SZ",
		22
	],
	"./Tw/sustainable-development/operating-governance/integrity-management.vue": [
		"M0SZ",
		22
	],
	"./Tw/sustainable-development/operating-governance/risk-management": [
		"RQ1p",
		8
	],
	"./Tw/sustainable-development/operating-governance/risk-management.vue": [
		"RQ1p",
		8
	],
	"./Tw/sustainable-development/operating-governance/succession-plan": [
		"MTon",
		64
	],
	"./Tw/sustainable-development/operating-governance/succession-plan.vue": [
		"MTon",
		64
	],
	"./Tw/sustainable-development/society-join/charitable-activities": [
		"86qc",
		16
	],
	"./Tw/sustainable-development/society-join/charitable-activities.vue": [
		"86qc",
		16
	],
	"./Tw/sustainable-development/society-join/faas": [
		"Pfnj",
		14
	],
	"./Tw/sustainable-development/society-join/faas.vue": [
		"Pfnj",
		14
	],
	"./Tw/sustainable-development/society-join/rural-connection": [
		"ccHU",
		19
	],
	"./Tw/sustainable-development/society-join/rural-connection.vue": [
		"ccHU",
		19
	],
	"./Tw/sustainable-development/society-join/social-impact": [
		"MkQS",
		4
	],
	"./Tw/sustainable-development/society-join/social-impact.vue": [
		"MkQS",
		4
	],
	"./Tw/sustainable-development/society-join/strategy": [
		"hcbO",
		63
	],
	"./Tw/sustainable-development/society-join/strategy.vue": [
		"hcbO",
		63
	],
	"./Tw/sustainable-development/supplier-management/chart-test": [
		"T4YR",
		62
	],
	"./Tw/sustainable-development/supplier-management/chart-test.vue": [
		"T4YR",
		62
	],
	"./Tw/sustainable-development/supplier-management/supplier-policy": [
		"m9Wq",
		18
	],
	"./Tw/sustainable-development/supplier-management/supplier-policy.vue": [
		"m9Wq",
		18
	],
	"./Tw/sustainable-development/supplier-management/supplier-result": [
		"zvbl",
		51
	],
	"./Tw/sustainable-development/supplier-management/supplier-result.vue": [
		"zvbl",
		51
	],
	"./Tw/sustainable-development/sustainable-operating/csr-download": [
		"YJhA",
		58
	],
	"./Tw/sustainable-development/sustainable-operating/csr-download.vue": [
		"YJhA",
		58
	],
	"./Tw/sustainable-development/sustainable-operating/operators": [
		"3KTC",
		44
	],
	"./Tw/sustainable-development/sustainable-operating/operators.vue": [
		"3KTC",
		44
	],
	"./Tw/sustainable-development/sustainable-operating/significant-issue": [
		"F8qH",
		23
	],
	"./Tw/sustainable-development/sustainable-operating/significant-issue.vue": [
		"F8qH",
		23
	],
	"./Tw/sustainable-development/sustainable-operating/stakeholder-channel": [
		"OQKU",
		49
	],
	"./Tw/sustainable-development/sustainable-operating/stakeholder-channel.vue": [
		"OQKU",
		49
	],
	"./Tw/sustainable-development/sustainable-operating/stakeholder-identification": [
		"5/tB",
		15
	],
	"./Tw/sustainable-development/sustainable-operating/stakeholder-identification.vue": [
		"5/tB",
		15
	],
	"./Tw/sustainable-development/sustainable-operating/sustainable-introduction": [
		"YuT8",
		38
	],
	"./Tw/sustainable-development/sustainable-operating/sustainable-introduction.vue": [
		"YuT8",
		38
	],
	"./Tw/sustainable-development/sustainable-operating/sustainable-performance": [
		"RIc8",
		3
	],
	"./Tw/sustainable-development/sustainable-operating/sustainable-performance.vue": [
		"RIc8",
		3
	],
	"./Tw/sustainable-development/sustainable-operating/sustainable-strategy-operation": [
		"dZcQ",
		26
	],
	"./Tw/sustainable-development/sustainable-operating/sustainable-strategy-operation.vue": [
		"dZcQ",
		26
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "RmSj";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/page lazy ^\.\/.*$
// module id = RmSj
// module chunks = 96